import React from 'react';
import styled, { useTheme } from 'styled-components';

import Icon, { IconType } from '../Icon';
import Link from '../Link';
import { TextProps } from '../Text';

export interface LinkButtonProps {
  iconRight?: IconType;
  iconLeft?: IconType;
  iconSize?: number;
  iconBackgroundColor?: string;
  iconColor?: string;
  children: React.ReactNode;
  disabled?: boolean;
  onClick: () => void;
}

const StyledLinkButton = styled(Link).attrs({
  as: 'button',
})<{ disabled: boolean }>`
  -webkit-appearance: none;
  background-color: transparent;
  border: 0;
  padding: 0;
  display: inline-flex;
  align-items: center;
  text-align: left;
`;

const StyledIconLeft = styled(Icon)<{ disabled: boolean }>`
  margin-right: 4px;
  cursor: ${({ disabled }) => (disabled ? 'default' : 'pointer')};
`;

const StyledIconRight = styled(Icon)<{ disabled: boolean }>`
  margin-left: 4px;
  cursor: ${({ disabled }) => (disabled ? 'default' : 'pointer')};
`;

const LinkButton = ({
  iconRight,
  iconLeft,
  iconSize = 16,
  iconColor,
  iconBackgroundColor,
  disabled = false,
  children,
  ...rest
}: LinkButtonProps & TextProps) => {
  const theme = useTheme();

  const defaultIconColor = iconColor ? iconColor : theme.linkButtonIconColor;

  return (
    <StyledLinkButton {...rest} disabled={disabled}>
      {iconLeft ? (
        <StyledIconLeft
          type={iconLeft}
          size={iconSize}
          color={disabled ? theme.linkButtonIconColorDisabled : defaultIconColor}
          backgroundColor={iconBackgroundColor}
          disabled={disabled}
        />
      ) : null}
      {children}
      {iconRight ? (
        <StyledIconRight
          type={iconRight}
          size={iconSize}
          color={disabled ? theme.linkButtonIconColorDisabled : defaultIconColor}
          backgroundColor={iconBackgroundColor}
          disabled={disabled}
        />
      ) : null}
    </StyledLinkButton>
  );
};

export default LinkButton;
